import { render, staticRenderFns } from "./baidu-fullscreen-control.vue?vue&type=template&id=f834b7f4"
import script from "./baidu-fullscreen-control.vue?vue&type=script&lang=js"
export * from "./baidu-fullscreen-control.vue?vue&type=script&lang=js"
import style0 from "./baidu-fullscreen-control.vue?vue&type=style&index=0&id=f834b7f4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f834b7f4')) {
      api.createRecord('f834b7f4', component.options)
    } else {
      api.reload('f834b7f4', component.options)
    }
    module.hot.accept("./baidu-fullscreen-control.vue?vue&type=template&id=f834b7f4", function () {
      api.rerender('f834b7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/map/baidu-fullscreen-control.vue"
export default component.exports